<template>
  <div class="crpg-m-common-zoom-image">
    <AtomsCommonZoomImage :image="img" :width="width" :height="height" :alt="alt" />
    <div class="crpg-m-common-zoom-image__click">
      <div class="crpg-m-common-zoom-image__click__left" v-on:mouseover="overLeft" v-on:mouseleave="leaveLeft" @click.stop="clickLeft">
        <span v-if="hoverLeftFlag" class="crpg-m-common-zoom-image__click__left__hover">PREV</span>
      </div>
      <div class="crpg-m-common-zoom-image__click__right" v-on:mouseover="overRight" v-on:mouseleave="leaveRight" @click.stop="clickRight">
        <span v-if="hoverRightFlag" class="crpg-m-common-zoom-image__click__right__hover">NEXT</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/molecules/common/zoomImage.scss";
</style>

<script>
import AtomsCommonZoomImage from "@/components/atoms/common/ZoomImage.vue";
export default {
  name: "MoleculesCommonZoomImage",
  components: {
    AtomsCommonZoomImage,
  },
  data() {
    return {
      img: null,
      width: 0,
      height: 0,
      alt: "",
      array: [],
      arrayNum: null,
      hoverLeftFlag: false,
      hoverRightFlag: false,
      imageWidth: 0,
      imageHeight: 0,
    };
  },
  mounted() {
    this.scroll();
    window.addEventListener("resize", this.showResize);
    this.showPicture();
  },
  methods: {
    showResize() {
      if (window.outerWidth < 450) {
        this.width = this.imageWidth / 3;
        this.height = this.imageHeight / 3;
      } else if (window.outerWidth < 900) {
        this.width = this.imageWidth / 2;
        this.height = this.imageHeight / 2;
      } else {
        let picture = this.$store.state.zoom;
        let arrayNum = picture.imageArray.findIndex((element) => element.url.match(picture.image));
        // アニメーションのために必要
        this.width = picture.imageArray[arrayNum].width;
        this.height = picture.imageArray[arrayNum].height;
      }
    },
    scroll() {
      /**
       * 拡大表示時の高さ調整
       */
      let h = document.body.clientHeight * 0.05;
      document.getElementsByClassName("crpg-m-common-zoom-image")[0].style.top = window.scrollY + h + "px";
    },
    /**
     * 拡大表示する画像を取得
     */
    showPicture() {
      let picture = this.$store.state.zoom;
      let showImage = require(`@/assets/img/${picture.showImg}/${picture.image}`);
      this.array = picture.imageArray;
      this.img = showImage;
      this.arrayNum = this.array.findIndex((element) => element.url.match(picture.image));
      // アニメーションのために必要
      this.width = picture.imageArray[this.arrayNum].width;
      this.height = picture.imageArray[this.arrayNum].height;
      this.alt = picture.imageArray[this.arrayNum].alt;
      this.imageWidth = this.width;
      this.imageHeight = this.height;
      this.showResize();
    },
    /**
     * ホバーで PREV 表示
     */
    overLeft() {
      if (this.arrayNum == 0) {
        this.hoverLeftFlag = false;
      } else {
        this.hoverLeftFlag = true;
      }
    },
    /**
     * ホバーで PREV 非表示
     */
    leaveLeft() {
      this.hoverLeftFlag = false;
    },
    /**
     * ホバーで NEXT 表示
     */
    overRight() {
      if (this.arrayNum == this.array.length - 1) {
        this.hoverRightFlag = false;
      } else {
        this.hoverRightFlag = true;
      }
    },
    /**
     * ホバーで NEXT 非表示
     */
    leaveRight() {
      this.hoverRightFlag = false;
    },
    /**
     * 前の画像へ遷移
     */
    clickLeft() {
      if (this.arrayNum > 0 && this.arrayNum < this.array.length) {
        this.arrayNum -= 1;
        this.img = require(`@/assets/img/${this.array[this.arrayNum].url}`);
        this.width = this.array[this.arrayNum].width;
        this.height = this.array[this.arrayNum].height;
        this.alt = this.array[this.arrayNum].alt;
        this.showResize();
      } else if (this.arrayNum == 0) {
        this.$store.dispatch("zoom/hide", [null, ""]);
      }
    },
    /**
     * 次の画像へ遷移
     */
    clickRight() {
      if (this.arrayNum >= 0 && this.arrayNum < this.array.length - 1) {
        this.arrayNum += 1;
        this.img = require(`@/assets/img/${this.array[this.arrayNum].url}`);
        this.width = this.array[this.arrayNum].width;
        this.height = this.array[this.arrayNum].height;
        this.alt = this.array[this.arrayNum].alt;
        this.showResize();
      } else if (this.arrayNum == this.array.length - 1) {
        this.$store.dispatch("zoom/hide", [null, ""]);
      }
    },
  },
};
</script>
